// Copyright (c) 2017 Deere & Company

export const auditListFilterOptions = [
    ['city'],
    ['leadAccount'],
    ['leadAccountName'],
    ['state']
];



// WEBPACK FOOTER //
// ./src/tcsm/audits/helpers/audit-list-filter-options.js